'use strict';

function LoanApplicationEmailBank() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._classes = {
    backToConnect: '.js--bank-to-connect',
    nextBtn: '.js--next',
    prevBtn: '.js--previous'
  };

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._$node = $(this.node);

    // Elements
    this._$prevBtn = this._$node.find(this._classes.prevBtn);
    this._$nextBtn = this._$node.find(this._classes.nextBtn);
    this._$backToConnect = this._$node.find(this._classes.backToConnect);

    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);

    // Remove Page Progress loader
    this._setupEventHandlers();
    this._removeProgressLoader();
  };

  this.destroy = function () {
    this._super();
  };

  this._setupEventHandlers = function () {
    _this._$prevBtn.on('click', function (e) {
      _this._history.goToUrl(_this.paths.loans.application_flow_connect_bank);
    });

    _this._$backToConnect.on('click', function (e) {
      _this._history.goToUrl(_this.paths.loans.application_flow_connect_bank);
    });

    _this._$nextBtn.on('click', function (e) {
      e.preventDefault();
      _this._$nextBtn.mogo().setDisabledLoadState();

      // Update ABS_status to `not_supported` to notify BE/CRM
      var payLoad = {};
      payLoad.abs_status = 'opt_out';
      _this._loanApplications[0].updateBankStatus(payLoad, {
        success: _this._onUpdateStatusSuccess.bind(_this),
        failure: _this._onUpdateStatusFailure.bind(_this)
      });
    });
  };

  this._onUpdateStatusSuccess = function (data, response) {
    $('#LoanApplicationTray').mogo()._loanAppSetStepComplete();
    _this._history.goToUrl(_this.paths.loans.application_flow_complete); // Animation page
  };

  this._onUpdateStatusFailure = function (data, response, request) {
    if (_this.isGeneralConnectionIssue(data, response)) {
      if (_this._errorInitialized === false) {
        _this._errorInitialized = true;

        _this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      _this._$nextBtn.mogo().removeDisabledLoadState();

      _this.analytics.pushEvent('loan-application-submission', {
        submission: ['Failure']
      });

      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };
}